import { lazy, Suspense } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { Hero } from "@/components/site/sections/Hero";
import { TrustLogos } from "@/components/site/sections/TrustLogos";
import { Stats } from "@/components/site/sections/Stats";
import spaceGrotesk700 from "@fontsource/space-grotesk/files/space-grotesk-latin-700-normal.woff2?url";

const HowItWorks = lazy(() =>
  import("@/components/site/sections/HowItWorks").then((m) => ({ default: m.HowItWorks })),
);
const WhyBizaclia = lazy(() =>
  import("@/components/site/sections/WhyBizaclia").then((m) => ({ default: m.WhyBizaclia })),
);
const Categories = lazy(() =>
  import("@/components/site/sections/Categories").then((m) => ({ default: m.Categories })),
);
const Testimonials = lazy(() =>
  import("@/components/site/sections/Testimonials").then((m) => ({ default: m.Testimonials })),
);
const FinalCTA = lazy(() =>
  import("@/components/site/sections/FinalCTA").then((m) => ({ default: m.FinalCTA })),
);

const HOME_TITLE = "Bizaclia — Portal inmobiliario para negocios";
const HOME_DESCRIPTION =
  "Encuentra, traspasa, vende o alquila locales, oficinas y naves en España. Acompañamiento humano y panel para gestionar tus operaciones.";
const HOME_URL = "https://bizaclia.com/";
const HOME_OG_IMAGE = "https://bizaclia.com/og-default.jpg";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: HOME_TITLE },
      { name: "description", content: HOME_DESCRIPTION },
      { property: "og:title", content: HOME_TITLE },
      { property: "og:description", content: HOME_DESCRIPTION },
      { property: "og:url", content: HOME_URL },
      { property: "og:type", content: "website" },
      { property: "og:image", content: HOME_OG_IMAGE },
      { property: "og:image:alt", content: "Bizaclia, portal inmobiliario para negocios" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: HOME_TITLE },
      { name: "twitter:description", content: HOME_DESCRIPTION },
      { name: "twitter:image", content: HOME_OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: HOME_URL },
      {
        rel: "preload",
        as: "font",
        type: "font/woff2",
        href: spaceGrotesk700,
        crossOrigin: "anonymous",
        fetchpriority: "high",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          name: "Bizaclia",
          url: "https://bizaclia.com",
          inLanguage: "es-ES",
          potentialAction: {
            "@type": "SearchAction",
            target: "https://bizaclia.com/anuncios?q={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        }),
      },
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Bizaclia",
          url: "https://bizaclia.com",
          logo: "https://bizaclia.com/favicon.ico",
        }),
      },
    ],
  }),
  component: Index,
});

function Index() {
  return (
    <main>
      <Hero />
      <TrustLogos />
      <Stats />
      <Suspense fallback={<div className="min-h-[400px]" />}>
        <HowItWorks />
        <WhyBizaclia />
        <Categories />
        <Testimonials />
        <FinalCTA />
      </Suspense>
    </main>
  );
}
